import React from 'react';
import styled from 'styled-components';
import congrats from 'resources/img/congrats.png';

const Page = styled.div`
  height: 100vh;
  background: white;
`;

const MessageContainer = styled.div`
  width: 536px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;

  img {
    object-fit: contain;
  }
`;

const MessageBodyContainer = styled.div`
  width: 536px;
  font-size: 18px;
  line-height: 20px;
  color: #000000;
  & > div:first-child {
    font-weight: bold;
    line-height: 24px;
  }
  & > div:last-child {
    font-size: 14px;
    margin-top: 8px;
  }
`;

export const MSTeamsSuccess = () => {
  const HEADING = 'Successfully Setup MS Teams';
  const BODY = 'Send alerts to this channel and begin responding to visitors from the Posts tab and the Chat Inbox.';
  return (
    <Page>
      <MessageContainer>
        <div className="d-flex justify-content-center">
          <img
            src={congrats}
            alt="msteams successfully setup"
            width="204px"
          />
        </div>
        <MessageBodyContainer className="text-center">
          <div>{HEADING}</div>
          <div>{BODY}</div>
        </MessageBodyContainer>
      </MessageContainer>
    </Page>
  );
};

export default MSTeamsSuccess;